/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ShippingPrice_shippingPriceResponseData$ref: FragmentReference;
declare export opaque type ShippingPrice_shippingPriceResponseData$fragmentType: ShippingPrice_shippingPriceResponseData$ref;
export type ShippingPrice_shippingPriceResponseData = {|
  +calculateShippingPrice: ?{|
    +itemShippingPrices: ?$ReadOnlyArray<?{|
      +sellerProductModelId: ?string,
      +shippingPrice: ?number,
    |}>,
    +totalShippingPrice: ?number,
  |},
  +$refType: ShippingPrice_shippingPriceResponseData$ref,
|};
export type ShippingPrice_shippingPriceResponseData$data = ShippingPrice_shippingPriceResponseData;
export type ShippingPrice_shippingPriceResponseData$key = {
  +$data?: ShippingPrice_shippingPriceResponseData$data,
  +$fragmentRefs: ShippingPrice_shippingPriceResponseData$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ShippingPrice_shippingPriceResponseData",
  "type": "ShippingPriceSchemaType",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "sellerProductModelIds",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "prefectureCode",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "quantities",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "calculateShippingPrice",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "prefectureCode",
          "variableName": "prefectureCode"
        },
        {
          "kind": "Variable",
          "name": "quantities",
          "variableName": "quantities"
        },
        {
          "kind": "Variable",
          "name": "sellerProductModelIds",
          "variableName": "sellerProductModelIds"
        }
      ],
      "concreteType": "ShippingPriceResponseSchemaType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "itemShippingPrices",
          "storageKey": null,
          "args": null,
          "concreteType": "shippingPriceItemResponseSchemaType",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "sellerProductModelId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "shippingPrice",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalShippingPrice",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '0c92eea65df1fc9a2819a942bc2f126e';
module.exports = node;
